import React from "react";
import { Block, Button, FieldArray, FormGroup, Input, PortletAccordionItem, TextInput, TextAreaInput } from "../../../../components";
import colors from "../../../../utils/colors";

export default function ListProfessionalExperience({ value = [] }) {
    return (
        <FieldArray
            name={"professionalExperience"}
            render={(arrayHelpers) => {
                return (
                    <>
                        {value.map((_item, index) => {
                            return (
                                <PortletAccordionItem
                                    key={index}
                                    title={"Experience" + " #" + (index + 1)}
                                    onClickDelete={() => arrayHelpers.remove(index)}
                                    onClickMoveDown={() => arrayHelpers.move(index, index + 1)}
                                    onClickMoveUp={() => arrayHelpers.move(index, index - 1)}
                                >
                                    <FormGroup title="Company">
                                        <Block width={456}>
                                            <Input Component={TextInput} name={`professionalExperience[${index}].company`} placeholder="Company name" />
                                        </Block>
                                    </FormGroup>
                                    <FormGroup title="Position">
                                        <Block width={456}>
                                            <Input Component={TextInput} name={`professionalExperience[${index}].position`} placeholder="Position in company" />
                                        </Block>
                                    </FormGroup>
                                    <FormGroup title="Duration">
                                        <Block width={456}>
                                            <Input Component={TextInput} name={`professionalExperience[${index}].duration`} placeholder="Duration of the job" />
                                        </Block>
                                    </FormGroup>
                                    <FormGroup title="Activities">
                                        <Block width={456}>
                                            <Input Component={TextAreaInput} name={`professionalExperience[${index}].activities`} placeholder="Activities in the company" />
                                        </Block>
                                    </FormGroup>
                                </PortletAccordionItem>
                            );
                        })}
                        <Block>
                            <Button width="100%" icon="plus_16px" color={colors.grey01} onClick={() => arrayHelpers.insert(value.length, {})} />
                        </Block>
                    </>
                );
            }}
        />
    );
}